export default "__VITE_ASSET__18428cff__"